module.exports = __webpack_public_path__ + "img/levelup.ec4597b1.png";